/***
 * @file:
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewEncapsulation,
} from '@angular/core';
import { UpdateEleClassService } from '@ithinkdt/shared/dom';

import { TransferChange, TransferItem } from '../transfer.interface';

@Component({
  selector: 'dt-transfer-list',
  preserveWhitespaces: false,
  providers: [UpdateEleClassService],
  templateUrl: './transfer-list.component.html',
  styleUrls: ['./transfer-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransferListComponent implements OnChanges, OnInit {
  constructor(
    private el: ElementRef,
    private updateHostClassService: UpdateEleClassService,
    private cdr: ChangeDetectorRef
  ) {}
  // #region fields

  @Input() direction = '';
  @Input() titleText = '';

  @Input() dataSource: TransferItem[] = [];

  @Input() itemUnit = '';
  @Input() itemsUnit = '';
  @Input() filter = '';
  @Input() disabled: boolean;
  @Input() showSearch: boolean;
  @Input() searchPlaceholder: string;
  @Input() notFoundContent: string;
  @Input() filterOption: (inputValue: string, item: TransferItem) => boolean;

  @Input() render: TemplateRef<void>;
  @Input() footer: TemplateRef<void>;

  @Input() allDropLists;
  @Input() id;

  // events
  @Output() readonly handleSelectAll: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() readonly handleSelect: EventEmitter<TransferItem> = new EventEmitter();
  @Output() readonly filterChange: EventEmitter<{ direction: string; value: string }> = new EventEmitter();
  @Output() readonly dragChange: EventEmitter<any> = new EventEmitter();

  prefixCls = 'ant-transfer-list';
  directions = ['left', 'right'];

  stat = {
    checkAll: false,
    checkHalf: false,
    checkCount: 0,
    shownCount: 0,
  };

  // ææ½äºä»¶
  drop(event: CdkDragDrop<string[]>) {
    // console.log("event", event, this.id)
    // console.log("this.allDropLists", this.allDropLists, "id", this.id)
    let from;
    let to;
    let list;
    const { previousIndex, currentIndex, previousContainer, container } = event;
    // console.log("previousContainer", previousContainer, "container", container, "previousIndex", previousIndex, "currentIndex", currentIndex)
    if (previousContainer === container) {
      moveItemInArray(container.data, previousIndex, currentIndex);
    } else {
      transferArrayItem(previousContainer.data, event.container.data, previousIndex, currentIndex);
    }
    list = container.data[currentIndex];
    if (previousContainer.id === container.id) {
      if (this.id === this.allDropLists[0]) {
        from = to = this.directions[0];
      } else {
        from = to = this.directions[1];
      }
    } else {
      if (this.id === this.allDropLists[0]) {
        from = this.directions[1];
        to = this.directions[0];
      } else {
        from = this.directions[0];
        to = this.directions[1];
      }
    }

    list.checked = false;
    this.updateCheckStatus();
    this.dragChange.emit({ from, to, list });
  }

  setClassMap(): void {
    const classMap = {
      [this.prefixCls]: true,
      [`${this.prefixCls}-with-footer`]: !!this.footer,
    };
    this.updateHostClassService.updateEleClass(this.el.nativeElement, classMap);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('footer' in changes) {
      this.setClassMap();
    }
  }

  ngOnInit(): void {
    this.setClassMap();
  }

  onHandleSelectAll(status: boolean): void {
    this.dataSource.forEach((item) => {
      if (!item.disabled && !item._hiden) {
        item.checked = status;
      }
    });

    this.updateCheckStatus();
    this.handleSelectAll.emit(status);
  }

  private updateCheckStatus(): void {
    const validCount = this.dataSource.filter((w) => !w.disabled).length;
    this.stat.checkCount = this.dataSource.filter((w) => w.checked && !w.disabled).length;
    this.stat.shownCount = this.dataSource.filter((w) => !w._hiden).length;
    this.stat.checkAll = validCount > 0 && validCount === this.stat.checkCount;
    this.stat.checkHalf = this.stat.checkCount > 0 && !this.stat.checkAll;
  }

  handleFilter(value: string): void {
    this.filter = value;
    this.dataSource.forEach((item) => {
      item._hiden = value.length > 0 && !this.matchFilter(value, item);
    });
    this.stat.shownCount = this.dataSource.filter((w) => !w._hiden).length;
    this.filterChange.emit({ direction: this.direction, value });
  }

  handleClear(): void {
    this.handleFilter('');
  }

  private matchFilter(text: string, item: TransferItem): boolean {
    if (this.filterOption) {
      return this.filterOption(text, item);
    }
    return item.title.includes(text);
  }

  markForCheck(): void {
    this.updateCheckStatus();
    this.cdr.markForCheck();
  }

  _handleSelect(item: TransferItem): void {
    if (this.disabled || item.disabled) {
      return;
    }
    item.checked = !item.checked;
    this.updateCheckStatus();
    this.handleSelect.emit(item);
  }
}
